import { useEffect } from 'react';
import { FieldProps, InputProps, useField } from 'informed';
import { InputWrapper, InputWrapperProps } from '../common';

interface TyInputProps extends InputProps, InputWrapperProps {
}

export const TyInput = (props: FieldProps<TyInputProps, string | number, any>) => {
  const { render, userProps, ref, fieldState, fieldApi } = useField(props);
  const { setValue, setTouched, setFocused } = fieldApi;
  const { maskedValue, showError, error } = fieldState;
  const { label, id, className, simple, icon, suffix, description, hidden, ...rest } = userProps;

  useEffect(() => {
    ref.current.setCustomValidity(error || '');
  }, [error, ref]);

  return render(
    <InputWrapper
      className={className}
      simple={simple}
      icon={icon}
      suffix={suffix}
      label={label}
      error={showError ? String(error) : undefined}
      description={description}
      hidden={hidden}
    >
      <input
        ref={ref}
        id={id}
        {...rest}
        value={!maskedValue && maskedValue !== 0 ? '' : maskedValue}
        onChange={(e) => {
          setValue(e.target.value, e);
        }}
        onBlur={(e) => {
          setTouched(true, e);
          setFocused(false, e);
        }}
        onFocus={(e) => {
          setFocused(true, e);
        }}
      />
    </InputWrapper>
  );
};
